import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    limit: 20,
    page: 1,
    total: 0,
    totalPages: 1,
};

export const blogTopicPageSlice = createSlice({
    name: "blogTopicPageSlice",
    initialState,
    reducers: {
        setBlogTopicPageLimit: (state, action) => {
            state.limit = action.payload;
        },
        setBlogTopicCurrentPage: (state, action) => {
            state.page = action.payload;
        },
        setBlogTopicTotalCount: (state, action) => {
            state.total = action.payload;
        },
        setBlogTopicTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        resetBlogTopicPagination: (state, action) => {
            state.limit = 20;
            state.page = 1;
            state.total = 0;
            state.totalPages = 1;
        },
    },
});

export const {
    setBlogTopicPageLimit,
    setBlogTopicCurrentPage,
    setBlogTopicTotalCount,
    setBlogTopicTotalPages,
    resetBlogTopicPagination,
} = blogTopicPageSlice.actions;

export default blogTopicPageSlice.reducer;